import { StateCreator } from 'zustand';

import { CommonStoreDef } from '@/models/inquiry.types';

export const common: StateCreator<CommonStoreDef> = (set) => ({
  isOutDated: false,
  setIsOutDated: (isOutDated) => set({ isOutDated }),
});
